export default __webpack_public_path__ + "static/media/aihack.e7e24b82.png";